<template>
    <div>
        <div ref="container" class="frc-captcha" :data-sitekey="siteKey" data-lang="fr"></div>
        <slot :captchaToken="captchaToken" :isCaptchaValid="widget && widget.valid"></slot>
    </div>
</template>

<script>
import { WidgetInstance } from "friendly-challenge";
import { isFunction } from "lodash";
import { EventBus } from "src/bus/eventBus";
import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            widget: null,
            container: null,
            captchaToken: null,
            siteKey: window.process.env.APP_DIODE_FRIENDLY_CAPTCHA_SITE_KEY,
        };
    },
    mounted() {
        if (this.$refs.container) {
            this.widget = new WidgetInstance(this.$refs.container, {
                startMode: "auto",
                doneCallback: this.doneCallback,
                errorCallback: this.errorCallback,
            });
        }
        EventBus.$on("captcha:reset", () => this.resetCaptcha());
    },
    unmounted() {
        if (this.widget && isFunction(this.widget.destroy)) {
            this.widget.destroy();
        }
    },
    methods: {
        doneCallback(solution) {
            this.captchaToken = solution;
            this.$emit("captcha:done", {
                captchaToken: solution,
                isCaptchaValid: this.widget && this.widget.valid,
            });
        },
        errorCallback(err) {
            console.log("There was an error when trying to solve the Captcha.");
            console.log(err);
            this.widget.reset();
        },
        resetCaptcha() {
            this.widget.reset();
        },
    },
});
</script>

<style lang="sass" scoped>
.frc-captcha
    max-width: 400px
    background-color: unset
</style>
